<h1 class="title">{{ 'dashboard.header' | translate }}</h1>
<nz-divider></nz-divider>
<app-notification-update-catalog-index></app-notification-update-catalog-index>
<div class="background-content">
<div class="action-monitoring-section">
    <div class="kpi-card">
        <app-dashboard-action-kpi appStretchedCard></app-dashboard-action-kpi>
    </div>
    <div class="kpi-card">
        <app-dashboard-monitoring-sheet-kpi appStretchedCard></app-dashboard-monitoring-sheet-kpi>
    </div>
</div>
<div class="monitoring-sheet-section">
    @if (dashboardMonitoringsheetVisible) {
    <app-dashboard-monitoring-sheet-index
        (resetComponentRequested)="handleReset($event)"></app-dashboard-monitoring-sheet-index>
    }
</div>
</div>